"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedMoment = void 0;
var _momentWithLocales = _interopRequireDefault(require("moment/min/moment-with-locales"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const momentLocales = {
  'no-NO': 'nb',
  'en-US': 'en',
  'da-DK': 'da',
  'fi-FI': 'fi',
  'hu-HU': 'hu',
  'it-IT': 'it',
  'et-EE': 'et',
  'ru-RU': 'ru'
};
const getLocalizedMoment = locale => {
  const localizedMoment = _momentWithLocales.default;
  const momentLocale = momentLocales[locale];
  localizedMoment.locale(momentLocale);
  return localizedMoment;
};
exports.getLocalizedMoment = getLocalizedMoment;